import React from "react";
// import Location from "assets/images/footer-images/address.svg";
// import Phone from "assets/images/footer-images/call.svg";
// import Email from "assets/images/footer-images/mail.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faLinkedinIn, faYoutube,faInstagram, faTiktok} from "@fortawesome/free-brands-svg-icons";
import OptimizedImage from "hooks/OptimizedImage";

export default function FooterContact() {
  return (
    <>
      <footer>
        <div className=" pb-10 bg-basecol text-gray px-10 md:pl-10 xl:px-0 lg:mb-[-100px] lg:pt-11">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 justify-items-start md:p-0 sm:p-7 md:pb-10 md:gap-y-14 xl:gap-y-0 items-center mb-20 xl:flex lg:items-start xl:gap-10">
            {/* lg:gap-x-12 */}
              <div className="hidden md:flex gap-4 lg:mr-10">
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_9001.webp" alt="ISO9001" className="w-24 lg:w-[100px] h-auto" />
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_17100.webp" alt="ISO17100" className="w-24 lg:w-[100px] h-auto" />
                <OptimizedImage src="https://tomedes.gumlet.io/assets/certificates/ISO_18587.webp" alt="ISO18587" className="w-24 lg:w-[100px] h-auto" />
              </div>
              <div className="font-opensans mb-10 lg:mb-0 md:mb-0">
                <div className="flex items-start">
                  <OptimizedImage src="https://tomedes.gumlet.io/assets/images/footer-images/address.svg" alt="address" className="mr-5 w-4" />
                  <div className="">
                    <p className="text-sm font-opensans font-normal text-[#C5C5C5] mb-[6px]">Tomedes Ltd - USA 9450 SW </p>
                    <p className="text-sm font-opensans font-normal text-[#C5C5C5] leading-7">Gemini Dr #34540, <span className="lg:block"> Beaverton, Oregon</span> </p>
                  </div>
                </div>
              </div>
              <div className="flex items-start mb-10 md:mb-0">
                <OptimizedImage src="https://tomedes.gumlet.io/assets/images/footer-images/call.svg" alt="contact" className="mr-5 w-4" />
                <div className="">
                  <p className="text-sm font-opensans font-normal text-[#C5C5C5] mb-[6px]">US: +1 985 239 0142</p>
                  <p className="text-sm font-opensans font-normal text-[#C5C5C5]">UK: +44 1615 096140 </p>
                </div>
              </div>
              <div className="md:mr-6 flex flex-col gap-10 md:gap-5 xl:mr-0">
                <div className="flex gap-1 items-center">
                <OptimizedImage src="https://tomedes.gumlet.io/assets/images/footer-images/mail.svg" alt="email" className="mr-5 w-4" />
                <p className="text-sm font-opensans font-normal text-[#C5C5C5]">support@tomedes.com </p>
                </div>
              <div className="flex items-center md:justify-start xl:col-span-full xl:justify-self-end">
                <div className="w-9/12 flex items-center justify-between">
                  <a className="p-2 social_media_icon_parent group" href="https://www.facebook.com/Tomedes.translation/" target="_blank">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faFacebookF} />
                  </a>
                  <a href="https://twitter.com/Tomedes" target="_blank" className="p-2 social_media_icon_parent group">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faTwitter} />
                  </a>
                  <a href="https://www.linkedin.com/company/tomedes.com" target="_blank" className="p-2 social_media_icon_parent group">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faLinkedinIn} />
                  </a>
                  <a href="https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw" target="_blank" className="p-2 social_media_icon_parent group">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faYoutube} />
                  </a>
                   <a href="https://www.instagram.com/tomedes_translation/" target="_blank" className="p-2 social_media_icon_parent group">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faInstagram} />
                  </a>
                  <a href="https://www.tiktok.com/@tomedestranslation" target="_blank" className="p-2 social_media_icon_parent group">
                    <FontAwesomeIcon className=" text-[26px] social_media_icon_hover inline-block cursor-pointer group-hover:text-lightBlue text-white" icon={faTiktok} />
                  </a>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
